module.exports = __webpack_public_path__ + "img/slide1-mb.66afa0aa.png";